import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Form, Formik } from "formik";
import Input from "../../../components/Input";
import Modal from "../../../components/Modal";
import { add, edit } from "../../../store/ActionsBtn/actions";

import messages from "../../../assets/locale/messages";
import {
  addFlashCardSubTopicRequest,
  addFlashCardTopicRequest,
  editFlashCardSubTopicRequest,
  editFlashCardTopicRequest
} from "../../../store/FlashCard/Topics/actions";
import {
  ADD_EDIT_CATEGORY_SCHEMA,
  getInitialValues
} from "./validations";
// import CustomSelect from "../../../components/Select";
// import { formatOptions } from "../../../utils/Helpers";
// import { useTheme } from "@material-ui/core";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const TopicsForm = ({
  isSubTopic,
  selectedTopicOrSubTopic,
  mode,
  isOpen,
  lang
}) => {
  const formRef = useRef();
  const { topicId } = useParams(); // This will be undefined on the main topics page

  const dispatch = useDispatch();
  const id = useSelector((state) => state.actionsBtn.edit);
  // const list = useSelector((state) => state.flashCardTopics.list);
  // const theme = useTheme();

  const {
    flashcard: {
      topic: { addTitle, editTitle, topicNameLabel, systemCodeLabel },
      subTopic: {
        addTitle: addSubTitle,
        editTitle: editSubTitle,
        subTopicNameLabel,
        subjectCodeLabel
      }
    }
  } = messages[lang];

  const handleSubmit = ({ name, subject_code, system_code }) => {
    if (isSubTopic) {
      const addData = {
        flashcard_sub_topic: { subject_code, name },
        topicId
      };
      const editData = {
        flashcard_sub_topic: { subject_code, name },
        topicId,
        id
      };

      mode === "add"
        ? dispatch(addFlashCardSubTopicRequest(addData))
        : dispatch(editFlashCardSubTopicRequest(editData));
    } else {
      const addData = { flashcard_topic: { name, system_code } };
      const editData = { name, system_code, id };

      mode === "add"
        ? dispatch(addFlashCardTopicRequest(addData))
        : dispatch(editFlashCardTopicRequest(editData));
    }
    handleModalCancel();
  };

  const handleModalSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  const handleModalCancel = () => {
    mode === "add" ? dispatch(add(false)) : dispatch(edit(false));
  };
  const modalTitleTopic = mode === "add" ? addTitle : editTitle;
  const modalTitleSubTopic =
    mode === "add" ? addSubTitle : editSubTitle;
  console.log("selectedTopicOrSubTopic", selectedTopicOrSubTopic);

  return (
    <Modal
      title={isSubTopic ? modalTitleSubTopic : modalTitleTopic}
      hasActions={true}
      isOpen={isOpen}
      handleModalSubmit={handleModalSubmit}
      handleModalCancel={handleModalCancel}
    >
      {/*  style={{ height: isSubTopic ? "200px" : "" }} */}
      <div>
        <Formik
          initialValues={getInitialValues({
            selectedTopicOrSubTopic,
            isSubTopic
          })}
          innerRef={formRef}
          onSubmit={handleSubmit}
          validationSchema={ADD_EDIT_CATEGORY_SCHEMA(
            lang,
            isSubTopic
          )}
        >
          {() => (
            <Form>
              <Input
                name={isSubTopic ? "subject_code" : "system_code"}
                isRequired={true}
                label={
                  isSubTopic ? subjectCodeLabel : systemCodeLabel
                }
              />
              <Input
                name="name"
                isRequired={true}
                label={
                  isSubTopic ? subTopicNameLabel : topicNameLabel
                }
              />
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
};

TopicsForm.propTypes = {
  isSubTopic: PropTypes.bool,
  mode: PropTypes.string,
  selectedTopicOrSubTopic: PropTypes.object,
  isOpen: PropTypes.bool,
  lang: PropTypes.string
};

TopicsForm.defaultProps = {
  isSubTopic: false,
  mode: "add",
  isOpen: false,
  selectedTopicOrSubTopic: {},
  lang: "en" // or whatever your default locale key is
};

export default TopicsForm;
